// Copyright (c) 2019 Sagacity Solutions Inc. All right reserved.
'use strict';

import Vue from "vue";
import Vuex from "vuex";

import api from '@/api';
import auth from './auth';
import patients from './patients';
import schedules from './schedules';
import tags from './tags';
import doses from './doses';
import language from './language';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    auth, patients, schedules, tags, doses, language,
  },
  state: {
    version: undefined,
  },
  mutations: {
    setVersion(state, version) {
      state.version = version
    }
  },
  actions: {
    async getVersion({ commit, state }) {
      if (state.version) {
        return state.version
      }
      let version = await api.getVersion();
      commit("setVersion", version)
      return version
    }
  },
  strict: debug,
});
